<script lang="ts">
    import {onMount} from "svelte";
    import {loadPaymentRequest} from "./loadPaymentRequest";
    import type {PaymentRequest} from "./loadPaymentRequest";
    import PrepareStripeCheckout from "./PrepareStripeCheckout.svelte";

    export let paymentRequest: string

    let loaded = false
    let loadedPaymentRequest: PaymentRequest | null = null
    let errorMessage = null

    onMount(async () => {
        await loadPaymentRequest(paymentRequest)
            .then((response) => loadedPaymentRequest = response as PaymentRequest)
            .catch((error: any) => errorMessage = error.message)
            .finally(() => loaded = true)
    })

</script>

{#if loaded}
    {#if errorMessage}
        <div class="mt-5 margin-auto text-center">
            <h2 class="text-danger">{errorMessage}</h2>
        </div>
    {:else}
        <PrepareStripeCheckout paymentRequest={loadedPaymentRequest}/>
    {/if}
{:else}
    <div class="mt-5 margin-auto text-center">
        <h2>Loading payment details...</h2>
    </div>
{/if}
